
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { dateToSeconds, getCurrentDate, pickerOptions } from '@/utils/dateTime'
import { getCurrency } from '@/utils/cookies'
import productOptionMixin from '@/mixin/productOption'
import { getProductList } from '@/api/product/product'
import { getProductAccountList } from '@/api/product/productAccount'
import {
  getDepositRankExport,
  getMerchantBalanceRank,
  getMerchantDepositRank,
  getMerchantWithdrawRank,
  getWithdrawRankExport
} from '@/api/dashboard'
import moment from 'moment'
import { delObjEmptyKey } from '@/utils'

const initDate = getCurrentDate()
@Component({
  name: 'rank'
})
export default class extends Vue {
  @Prop() private data!: any
  @Prop() private form!: any
  @Prop() private dateTime!: any

  get language() {
    return AppModule.language
  }
  private reatData: any = {}
  private currentRank: string = 'Deposit'
  private currentRank1: string = '入金'
  private currentRank2: string = '入金'

  queryForm: any = {
    currency: '',
    merchant_no: null,
    start_time: initDate[0],
    end_time: initDate[1],
    id: null
  }
  private date: any[] = getCurrentDate()
  private pickerOptions = pickerOptions
  private currencyTypes = AppModule.enterprise.available_currency
  private loading: boolean = false

  private balanceRank: any[] = []
  private depositRank: any[] = []
  private withdrawRank: any[] = []

  // 创建时间监听
  @Watch('date', { deep: true, immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }

  @Watch('queryForm.currency')
  onCurrencyChange() {
    this.getProductList()
  }

  @Watch('queryForm.product_code')
  onProductChange() {
    this.getProductAccountList()
  }

  private dialogVisible: boolean = false
  private openVisible() {
    this.dialogVisible = true
  }

  @Watch('dialogVisible', { immediate: true })
  private wacthVisible() {
    if (this.dialogVisible === true) {
      this.queryForm = {
        currency: AppModule.currentCurrencyType,
        merchant_no: null,
        start_time: null,
        end_time: null,
        product_code: null,
        product_account_no: null,
        ant_username: null
      }
      this.date = getCurrentDate()
      if (this.data) {
        this.reatData = this.data
      }
      this.queryForm = this.form
      this.date = this.dateTime
    }
  }

  // 获取产品列表
  private onProductList: any[] = []
  private async getProductList() {
    const data: any = {
      status: 1
    }
    await getProductList(data).then((res: any) => {
      this.onProductList = res.filter((item: any) => {
        return this.queryForm.currency === item.currency
      })
    })
  }

  // 获取产品账户列表
  private productAccountList: any[] = []
  private async getProductAccountList(acountName?: string) {
    try {
      if (this.queryForm.product_code) {
        const data: any = {
          product_code: this.queryForm.product_code,
          account_name: acountName ? acountName : '',
          page_size: 100
        }
        await getProductAccountList(data).then((res: any) => {
          this.productAccountList = res.results
        })
      }
    } catch (e) {}
  }

  private async select() {
    await this.getMerchantBalanceRank()
    await this.getMerchantDepositRank()
    await this.getMerchantWithdrawRank()
    const obj = {
      balanceRank: this.balanceRank,
      depositRank: this.depositRank,
      withdrawRank: this.withdrawRank
    }
    this.reatData = obj
  }

  private async reset() {
    this.queryForm = {
      currency: AppModule.currentCurrencyType,
      merchant_no: null,
      start_time: null,
      end_time: null,
      product_code: null,
      product_account_no: null,
      ant_username: null
    }
    this.date = getCurrentDate()
    // if (this.data) {
    //   this.reatData = this.data
    // }
    this.$nextTick(async () => {
      await this.getMerchantBalanceRank()
      await this.getMerchantDepositRank()
      await this.getMerchantWithdrawRank()
    })
  }

  // 获取商户可用余额排行榜
  private async getMerchantBalanceRank() {
    try {
      this.loading = true
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getMerchantBalanceRank(data).then((res: any) => {
        this.balanceRank = res
        this.loading = false
      })
    } catch (e) {}
  }

  // 获取商户入金排行榜
  private async getMerchantDepositRank() {
    try {
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getMerchantDepositRank(data).then((res: any) => {
        this.depositRank = res
      })
    } catch (e) {}
  }

  // 获取商户出金排行榜
  private async getMerchantWithdrawRank() {
    try {
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getMerchantWithdrawRank(data).then((res: any) => {
        this.withdrawRank = res
      })
    } catch (e) {}
  }

  // 导出
  private downloadVisible: boolean = false
  private downloadRadio: string = '1'
  private openDownload() {
    this.downloadVisible = true
  }
  private async download() {
    const data: any = {
      ...this.queryForm
    }
    delObjEmptyKey(data)
    if (this.downloadRadio === '1') {
      await getDepositRankExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.downloadVisible = false
      })
    } else {
      await getWithdrawRankExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.downloadVisible = false
      })
    }
  }

  mounted() {
    if (this.data) {
      this.reatData = this.data
    }
  }
}
